// extracted by mini-css-extract-plugin
export default {"GlobalRetail":"GlobalRetail_GlobalRetail__3IvSK","institutionalTitle":"GlobalRetail_institutionalTitle__oY-QS","institutionalPara":"GlobalRetail_institutionalPara__7PkKp"};